<div class="row">

  <div class="col-md-6">
    <div class="box" [ngClass]="{'box-primary': !this.isEditing, 'box-warning': this.isEditing }">

      <div class="box-header text-center">
        <h3 class="box-title ">Rotina Padrão Cadastradas</h3><br />
        <span class="text-muted">Selecione para editar</span>
        <div class="divider"></div>
      </div>

      <div class="box-body">


        <div class="form-row">
          <div class="col-md-12">
            <div class="position-relative form-group">
              <label for="areaTecnicaId">Área técnica</label>
              <select class="form-control" #controlAreaTecnicaId id="controlAreaTecnicaId" required
                (change)="changeAreaTecnica(controlAreaTecnicaId.value)">
                <option value="">selecione</option>
                <option *ngFor="let t of areasTecnicas" [value]="t.id">{{ t.nome }}</option>
              </select>
            </div>
          </div>
        </div>



        <div class="box-table h550">
          <table>
            <thead>
              <tr>
                <th class="text-center wf120"><i *ngIf="this.isLoading"
                    class="fa fa-spinner fa-spin fa-fw pull-left"></i>Código</th>
                <th class="text-center">Descrição</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let c of cadastrados" class="cp" (click)="getById(c.id)"
                [ngClass]="{'tr-info': c.id == this.form.get('id').value}">
                <td class="text-center">{{ c.codigo }}</td>
                <td class="text-left">{{ c.descricao }}</td>
              </tr>
              <!-- <tr *ngFor="let v of this.voids">
                <td></td>
                <td></td>
              </tr> -->
            </tbody>
          </table>
        </div>
      </div>
      <div class="box-footer">
        <span class="pl-1">Total: <b>{{ this.cadastrados?.length }}</b> </span>
      </div>
    </div>
  </div>



  <div class="col-md-6">
    <div class="box bord" [ngClass]="{'box-primary': !this.isEditing, 'box-warning': this.isEditing }">

      <div class="box-body ">

        <form novalidate [formGroup]="form" id="form" (validSubmit)="submit()" class="pt-0">

          <div class="form-row">
            <div class="col-md-5">
              <div class="position-relative form-group">
                <label for="">Código</label>
                <input class="form-control" formControlName="codigo" type="text" maxlength="7" required
                  [readonly]="areaTecnicaId == 0">
                <section *ngIf="!form.valid" class="form-text text-danger pl-2">
                  <small *ngIf="form.get('codigo').hasError('isNotUniqueCodigo')">Este código de rotina já está
                    uso</small>
                </section>
              </div>
            </div>
            <div class="col-md-3">
              <div class="position-relative form-group">
                <label for="">Duração</label>
                <input currencyMask class="form-control" formControlName="duracao" type="text" maxlength="8" required
                  [readonly]="this.areaTecnicaId == 0" [options]="{ prefix: '', thousands: '.', decimal: ',' }">
                <section *ngIf="!form.valid" class="form-text text-danger pl-2">
                  <small *ngIf="form.get('duracao').hasError('invalid')">Verifique o valor</small>
                </section>
              </div>
            </div>

            <div class="col-md-4">
              <div class="position-relative form-group">
                <label for="">Unidade de tempo</label>
                <select for="" class="form-control" formControlName="unidadeTempo" required>
                  <option value="null">selecione</option>
                  <option value="MN">Minutos</option>
                  <option value="HH">Horas</option>
                  <option value="DD">Dias</option>
                  <option value="SS">Semanas</option>
                  <option value="ME">Meses</option>
                </select>
              </div>
            </div>


          </div>


          <div class="form-row">
            <div class="col-md-12">
              <div class="position-relative form-group">
                <label for="">Descrição</label>
                <input class="form-control" formControlName="descricao" type="text" maxlength="100" required
                  [readonly]="this.areaTecnicaId == 0">
              </div>
            </div>
          </div>

          <div class="form-row">
            <div class="col-md-12">
              <div class="position-relative form-group">
                <label for="">Instrução de trabalho</label>
                <textarea rows="3" class="form-control" formControlName="instrucaoDeTrabalho" required
                  [readonly]="this.areaTecnicaId == 0"></textarea>
              </div>
            </div>
          </div>




          <div class="form-row">
            <div class="col-md-12">
              <div class="form-group mb-0">
                <label for="">Arquivos anexos</label>
              </div>
            </div>
          </div>

          <div class="form-row">
            <div class="col-md-12">
              <div class="box-table ml-1" style="height: 125px;border: solid #ccc 1px">
                <table>
                  <thead>
                    <tr>
                      <th>Arquivo</th>
                      <th class="wf20"></th>
                      <th class="wf20"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let t of this.arquivos">
                      <td class="text-center">{{ t.nomeOriginal }}</td>
                      <td><i class="fa fa-eye text-primary text-center cp"
                          (click)="showFile(t.nome, t.nomeOriginal, modalViewerPdf)"></i></td>
                      <td><i class="fa fa-trash text-danger text-center cp" (click)="removeArquivo(t)"></i></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

          </div>

          <div class="form-row mt-2">
            <div class="col-md-6 mb-2 text-left">
              <span *ngIf="this.arquivos.length > 0" class="pl-1">Total de arquivos:
                <b>{{ this.arquivos.length }}</b>
              </span>
            </div>

            <div class="col-md-6">
              <button type="button" class="btn btn-light btn-block" (click)="fileInput.click()" title="Upload arquivos"
                [disabled]="this.areaTecnicaId == 0 || (!(!this.isEditing && this.autorizacoes?.podeIncluir) && !(this.isEditing && this.autorizacoes?.podeAlterar))">
                <i class="fa fa-plus-circle text-primary pull-left"></i>Adicionar Arquivos
              </button>
            </div>
          </div>



          <input hidden #fileInput type="file" accept="*.*" id="fileInput"
            (change)="handleFiles($event.target.files)" />


          <div class="row">

            <div class="col-md-12 text-center">
              <table class="table table-bordered table-hover">
                <thead class="thead-default">
                  <tr>
                    <th class="header vam w20p">Classe rotina</th>
                    <th class="header vam">Periodicidade</th>
                    <th class="header vam w30p">valor</th>
                  </tr>
                </thead>
                <tbody class="tbody-default">

                  <tr *ngFor="let classe of this.classesRotinas">
                    <td class="text-center">{{classe}}</td>
                    <td>
                      <div class="input-group">

                        <select class="form-control selectPeriodicidade" 
                          (change)="changePeriodicidade($event.target.value, classe)" #selectPeriodicidade
                          [disabled]="this.areaTecnicaId == 0">
                          <option *ngFor="let i of this.periodicidadesIndexes" [value]="i">{{this.periodicidadesStr[i]}}
                          </option>
                        </select>
                        <div class="input-group-append cp" (click)="setAllSamePeriodicidade(selectPeriodicidade.value)"
                          title="Todas classes rotina como esta">
                          <span class="input-group-text"><i class="fa fa-check-circle-o"></i></span>
                        </div>

                      </div>
                    </td>
                    <td>
                      <input class="form-control text-center" [formControlName]="formEspacamentos[classe]" type="text"
                        required digitOnly maxlength="3"
                        [readonly]="this.areaTecnicaId == 0 || this.form.get(this.formPeriodicidadeIndex[classe]).value > 0">
                    </td>
                  </tr>



                </tbody>
              </table>


              <section *ngIf="!form.valid && !this.isValidPeriodicidade" class="pl-2 txt-danger">
                <p>A periodicidade de um classe rotina deve ser maior ou igual a anterior</p>
              </section>

            </div>
          </div>




        </form>

      </div>
      <div class="text-center">
        <app-ball-pulse *ngIf="isProcessing"></app-ball-pulse>
      </div>
    </div>

  </div>
</div>

<div class="row mt-3">
  <div class="col-md-12">
    <div class="box" [ngClass]="{'box-primary': !this.isEditing, 'box-warning': this.isEditing }">
      <div class="box-body">
        <div class="row">
          <div class="col-md-4">
            <div class="d-flex justify-content-start">
              <button type="button" class="btn btn-light pl-3 pr-3 mr-3"
                [disabled]="!(this.isEditing && this.autorizacoes?.podeExcluir)"
                title="Exluir categoria funcional selecionada" (click)="showModalSm(modaldelete)">
                <span class="text-danger"><i class="fa fa-trash"></i></span><span class="pl-3">Excluir</span>
              </button>
            </div>
          </div>
          <div class="col-md-4">
            <div class="d-flex justify-content-center">
              <a [routerLink]="['/home']" title="Tela Principal"><img src="./assets/images/homePeq.png" /></a>
            </div>
          </div>
          <div class="col-md-4">

            <div class="d-flex justify-content-end">

              <button type="button" class="btn btn-light pl-5 pr-5 mr-3" (click)="reset()">Limpar</button>
              <button type="submit" class="btn pl-5 pr-5 mr-3 btn-shadow" form="form"
                [disabled]="(this.areaTecnicaId == 0 || (!(!this.isEditing && this.autorizacoes?.podeIncluir) && !(this.isEditing && this.autorizacoes?.podeAlterar))) || this.isProcessing"
                [ngClass]="{'btn-primary': !this.isEditing, 'btn-warning': this.isEditing }">
                <span *ngIf="!this.isEditing">Cadastrar</span>
                <span *ngIf="this.isEditing">Editar</span>
              </button>
            </div>

          </div>

        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #modaldelete let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title">SIGEM CLOUD</h4>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-md-3">
        <div class="d-flex justify-content-center">
          <img src="assets\images\icon-question.png" />
        </div>
      </div>
      <div class="col-md-9">
        <div class="alert alert-warning">
          <div class="d-flex justify-content-center">
            <span class="question-modal pt-3 pb-3">Deseja excluir a <b>rotina</b> selecionada?</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <div class="row">
      <div class="col-md-6"></div>
      <div class="col-md-6">
        <div class="d-flex justify-content-end">
          <button type="button" class="btn btn-light pl-5 pr-5 mr-3" (click)="c('Close click')">Não</button>
          <button type="button" class="btn btn-primary btn-shadow pl-5 pr-5 mr-2"
            (click)="delete(this.form.get('id').value, c)">Sim</button>
        </div>
      </div>
    </div>
  </div>
</ng-template>



<!-- ------------------------------------------ -->

<iframe *ngIf="this.fileType == 'diverso'" [src]="uriFileStringOrBase64 | safe" hidden></iframe>

<ng-template #modalViewerPdf let-c="close" let-d="dismiss">
  <div class="modal-body" style="padding: 0px; background-color: #141518;">
    <div class="row">
      <div class="col-md-12 text-center" style="padding:10px; background: #141518 ;">
        <img *ngIf="this.fileType == 'image'" [src]="uriFileStringOrBase64 | safe" class="img-thumbnail">
        <iframe *ngIf="this.fileType == 'pdf'" [src]="uriFileStringOrBase64 | safe"
          style="width: 560px; height: 640px;"></iframe>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12" style="padding:10px; background: #141518 ; border-top: 2px solid #515558;">
        <div class="text-right">
          <button type="button" class="btn btn-secondary pl-5 pr-5 mr-4" (click)="c('Close click')">Fechar</button>
        </div>
      </div>
    </div>
  </div>
</ng-template>